var __TEMP__ = require('./_trimmedEndIndex.js');var trimmedEndIndex = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseTrim;
